export function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

export const getPageUrl = (handle: any) => {
  if (handle.includes('reebelos-gift-card')) {
    return `/${handle}`;
  }

  return `/collections/${handle}`;
};
